export enum ComparisonOperator {
  EQUALS = "EQUALS",
  NOT_EQUALS = "NOT_EQUALS",
  INCLUDES = "INCLUDES",
  NOT_INCLUDES = "NOT_INCLUDES",
  LESS_THAN = "LESS_THAN",
  LESS_THAN_OR_EQUAL_TO = "LESS_THAN_OR_EQUAL_TO",
  GREATER_THAN = "GREATER_THAN",
  GREATER_THAN_OR_EQUAL_TO = "GREATER_THAN_OR_EQUAL_TO",
  REGEXP = "REGEXP",
}
